import { render, staticRenderFns } from "./invite-add.vue?vue&type=template&id=29f97e5c&scoped=true"
import script from "./invite-add.vue?vue&type=script&lang=js"
export * from "./invite-add.vue?vue&type=script&lang=js"
import style0 from "./invite-add.vue?vue&type=style&index=0&id=29f97e5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f97e5c",
  null
  
)

export default component.exports